import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ECallActive } from './types';

export const setCallActive = actionGenerator<ECallActive.SetCallActive>(ECallActive.SetCallActive);
export const clearCallActive = actionGenerator<ECallActive.ClearCallActive>(ECallActive.ClearCallActive);
